import * as React from "react";
import { forwardRef } from "react";
const SvgNoteIcon = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 62, height: 62, viewBox: "0 0 62 62", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("rect", { width: 62, height: 62, rx: 12, fill: "#F9F8FD" }), /* @__PURE__ */ React.createElement("path", { d: "M19.6665 22.5H42.3332M19.6665 28.1667H42.3332M19.6665 33.8333H42.3332M19.6665 39.5H35.2498", stroke: "black", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgNoteIcon);
export default ForwardRef;
